module.exports = __webpack_public_path__ + "img/24.11391ca6.png";